import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from 'src/locales/en.json';
import ta from 'src/locales/ta.json';

const savedLanguage = localStorage.getItem('selectedLanguage');

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: en,
      ta: ta
      // Add translations for other languages as needed
    },
    lng: savedLanguage || 'en', // Use saved language or default to 'en'
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
